var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.956 7.214-2.939 15.344s-.411 1.064-1.54.553l-6.782-5.384-.032-.016c.916-.851 8.02-7.465 8.33-7.765.48-.464.182-.74-.376-.39l-10.492 6.9-4.048-1.41s-.637-.235-.698-.745c-.062-.511.719-.787.719-.787L21.6 6.81s1.356-.617 1.356.404z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.7b41829663b02d643bdab355b79e7d90.svg";
export { ForwardRef as ReactComponent };